/**
 * Route paths for the B2B marketing pages. Centralised so the URLs can be
 * changed in one place — the pages themselves are URL-agnostic components.
 *
 * In production these are served from the business subdomain via an edge
 * rewrite (see `app/modules/b2b/BUSINESS_SUBDOMAIN.md`):
 *   business.archiproamerica.com/                → /b2b
 *   business.archiproamerica.com/brands          → /b2b/brands
 *   business.archiproamerica.com/professionals   → /b2b/professionals
 */
export const B2B_BRANDS_PATH = '/b2b/brands';
export const B2B_PROFS_PATH = '/b2b/professionals';
